/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { css, cx } from "@panda/css";
import { Box, BoxProps } from "@panda/jsx";

const tableBodyStyles = css({
	position: "relative",
	margin: "0 auto",
	display: "grid",
	gridTemplateColumns: "subgrid",
	gridColumn: "1 / -1",
	borderRadius: "var(--table-border-radius, token(radii.eds.borderRadius.12))",
	"&::before": {
		content: "''",
		position: "absolute",
		zIndex: "1",
		top: "0",
		right: "0",
		bottom: "0",
		left: "0",
		pointerEvents: "none",
		borderRadius: "var(--table-border-radius, token(radii.eds.borderRadius.12))",
		border: "token(spacing.eds.dimension.1) solid token(colors.eds.palette.transparent.light.005)",
	},
	"& .cosmos-table__row:first-child": {
		borderTopLeftRadius: "var(--table-border-radius, token(radii.eds.borderRadius.12))",
		borderTopRightRadius: "var(--table-border-radius, token(radii.eds.borderRadius.12))",
	},
	"& .cosmos-table__row:last-child": {
		borderBottomLeftRadius: "var(--table-border-radius, token(radii.eds.borderRadius.12))",
		borderBottomRightRadius: "var(--table-border-radius, token(radii.eds.borderRadius.12))",
	},
});

export interface CosmosTableBodyProps extends BoxProps {
	className?: string;
	children: React.ReactNode;
}

/**
 * Expects to wrap one or more TableRows, applies an outer border and border radius
 */

export const CosmosTableBody = ({ className, children, ...props }: CosmosTableBodyProps): React.JSX.Element => {
	return (
		<Box gap="eds.dimension.2" {...props} className={cx("cosmos-table__body", tableBodyStyles, className)}>
			{children}
		</Box>
	);
};

CosmosTableBody.displayName = "CosmosTable.Body";
